const file_max_size = 20;
const image_types = ["JPG", "PNG", "JPEG"];
const file_types = [...image_types, "DOC", "DOCX", "PDF"];

export { file_max_size, file_types, image_types };
